import { Stack, Typography } from "@mui/material";
import { memo } from "react";

import { CollapsibleCard } from "@/components/elements/CollapsibleCard";
import { FlowStepsBox } from "@/features/organization/invoice/components/invoice-form/FlowStepsBox";
import { BILLING_FLOW_STEPS } from "@/features/organization/invoice/constants/invoiceEnums";
import { text } from "@/theme/colors";

/** 請求フロー設定 — 適用中のフロー (fixed billing flow chain). */
export const BillingFlowSection = memo(() => (
  <CollapsibleCard title="請求フロー設定">
    <Stack gap={0.5}>
      <Typography variant="cap12" color={text.primary}>
        適用中のフロー
      </Typography>
      <FlowStepsBox steps={BILLING_FLOW_STEPS} />
    </Stack>
  </CollapsibleCard>
));

BillingFlowSection.displayName = "BillingFlowSection";
